module.exports = __webpack_public_path__ + "media/MRI10C.fa7b8387.mp3";